var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingstarsunfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9092 0.869652L8.72114 7.3337L1.58824 8.37361C0.309098 8.55913 -0.203534 10.1361 0.724086 11.0393L5.88458 16.068L4.66403 23.1716C4.44433 24.4556 5.7967 25.4174 6.92937 24.8169L13.3104 21.4628L19.6915 24.8169C20.8241 25.4125 22.1765 24.4556 21.9568 23.1716L20.7363 16.068L25.8968 11.0393C26.8244 10.1361 26.3117 8.55913 25.0326 8.37361L17.8997 7.3337L14.7116 0.869652C14.1404 -0.282549 12.4853 -0.297196 11.9092 0.869652Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingstarsunfilled);
export default __webpack_public_path__ + "static/media/ratingstarsunfilled.97dc3497971038eaa7e6e695b44a6761.svg";
export { ForwardRef as ReactComponent };